export const ContentBlockClassNames = {
    INVERTED: 'content-block_inverted',
};
